import { ProductSaveLabelStyle } from '@/components/ProductPrice/ProductPrice.styled'
import { useTranslations } from '@/hooks/useTranslations'

import type React from 'react'
import type { SxProps } from '@mui/material'

interface ProductSaveLabelsProps {
  saveLabel: string
  percentage?: number
  productDetails?: boolean
  productCart?: boolean
  productList?: boolean
  sx?: SxProps
}

export const ProductSaveLabels: React.FC<ProductSaveLabelsProps> = ({
  saveLabel,
  percentage = null,
  productCart,
  productList,
  sx,
}) => {
  const { translate } = useTranslations()
  const saveText = percentage
    ? translate('product.saveLabelPercentage', { saveLabel })
    : translate('product.saveLabel', { saveLabel })
  const classLabelSaveName = productCart ? 'productCart' : productList ? 'productList' : null

  return (
    <ProductSaveLabelStyle className={classLabelSaveName} sx={{ ...sx }} variant="body1">
      {saveText}
    </ProductSaveLabelStyle>
  )
}
